import React, { useEffect, useState } from 'react'
import Popup from '../replaceAntd/popup'
import globalData from '../../common/globalData'
import Icon from '../icon'
import { IDEA_MASS_ROLE } from '../enum'
import './index.less'

/**
 * @description: 权限说明组件
 * @return 根据不同的权限显示不同信息
 */

const ROLE_LIST = [
  {
    key: IDEA_MASS_ROLE.OWNER,
    icon_type: 'm-yonghu',
    role: '拥有者',
    introduce: ['新增、编辑、删除款式&子灵感集', '编辑、删除灵感集', '转让灵感集'],
  },
  {
    key: IDEA_MASS_ROLE.AUDITOR,
    icon_type: 'm-shenhe',
    role: '审核者',
    introduce: ['新增、编辑、删除所有款式&子灵感集'],
  },
  {
    key: IDEA_MASS_ROLE.GATHER,
    icon_type: 'm-bianji',
    role: '采集者',
    introduce: ['新增、编辑、删除自己创建的款式&子灵感'],
  },
  {
    key: IDEA_MASS_ROLE.VIEWER,
    icon_type: 'm-xianshi',
    role: '查看者',
    introduce: ['查看款式&子灵感集'],
  },
]

export default ({ currentRole, children, placement = 'bottomLeft', defaultVisible }) => {
  const [visible, setVisible] = useState(false)
  const [step, setStep] = useState(1)

  useEffect(() => {
    globalData.get(
      'mn-authorityIntroduced-key-count',
      (val) => {
        setStep(val)
        if (val <= 3) {
          setVisible(defaultVisible)
        }
      },
      1
    )
  }, [])

  useEffect(() => {
    defaultVisible && globalData.set('mn-authorityIntroduced-key-count', step + 1)
  }, [step])

  const menu = (
    <div className="mn-introduce-container">
      {ROLE_LIST.map((item) => (
        <div key={item.key} className="item-user">
          <div className="user-left">
            <Icon type={item.icon_type} className="user-icon" />
          </div>
          <div className="user-right">
            <div className="right-top">
              <div className="user-role">{item.role}</div>
              {currentRole === item.key && <div className="current-role">当前角色</div>}
            </div>
            <div className="right-bottom">
              <div className="item-introduce">{item.introduce[0]}</div>
              <div className="item-introduce">{item.introduce?.[1]}</div>
              <div className="item-introduce">{item.introduce?.[2]}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
  return (
    <span>
      {children || '权限说明'}
      <Popup visible={visible} onVisibleChange={(e) => setVisible(e.value)} position={placement} trigger="hover">
        {menu}
      </Popup>
    </span>
  )
}
